import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Toast from "../../Utils/Toast";

import Page from "../Page/Page";

const Forum = (props) => {
  const navigator = useNavigate();
  const { state } = useLocation();

  // ===================================

  useEffect(() => {
    Toast("warning", "این بخش درحال حاضر در درسترس نیست!");
    navigator(state?.prevPath || "/hisstori/home");
  }, []);

  // ===================================

  return (
    <Page>
      <h1>Forum</h1>
    </Page>
  );
};

export default Forum;
